import styled from 'styled-components';

interface LinkStyledProps {
    onClick: () => void;
}
 export const LinkStyled = styled.a<LinkStyledProps>`
    color: #4A90E2 !important;
    cursor: pointer;
`